// extracted by mini-css-extract-plugin
export default {"about":"About_about__FAXt2","content":"About_content__w7JWa","logoFloat":"About_logoFloat__YXUn6"};